import { useDispatch } from 'react-redux';
import { IconButton, Tooltip } from '@material-ui/core';
import { translate } from '@utils';
import { FilterListOffIcon } from '@images/icons';
import { resetAnswerFilters } from '@actions/answersPageAction';
import '../index.scss';

export const ClearFiltersLabel = () => {
  const dispatch = useDispatch();

  return (
    <>
      <Tooltip title={translate('clear_filters')} arrow>
        <IconButton
          size="small"
          color="primary"
          aria-label="filtering"
          data-testid="clear-answers-filters"
          component="div"
          onClick={() => {
            dispatch(resetAnswerFilters());
          }}
        >
          <FilterListOffIcon />
        </IconButton>
      </Tooltip>
    </>
  );
};
